module.exports = __webpack_public_path__ + "img/p.6a59562d.jpg";